export default __webpack_public_path__ + "static/media/work-process-2.0196165b.jpg";